import baseApi from '../utils/ApiUtils';

export const loanApi= (method, payload = null, params = null) => {
  return baseApi(`/loans/`, method, params, payload).then(response => {
    return response.data;
  });
};

export const loansAction= (method, id, payload = null, params = null) => {
  return baseApi(`/loans/${id}/`, method, params, payload).then(response => {
    return response.data;
  });
};

export const loanTransition= (method, id, payload = null, params = null) => {
  return baseApi(`/loans/${id}/transition/`, method, params, payload).then(response => {
    return response.data;
  });
};

export const loanTaskPoolService= (method, id, payload = null, params = null) => {
  return baseApi(`/loans/${id}/task_pools/`, method, params, payload).then(response => {
    return response.data;
  });
};

export const loansActivityLogService= (method, id, payload = null, params = null) => {
  return baseApi(`/loans/${id}/activity_logs/`, method, params, payload).then(response => {
    return response.data;
  });
};

export const loansReportApi = (method, params = null, payload = null) => {
  return baseApi(`reports/loans/?format=csv`, method, params, payload, 'blob').then(response => {
    return response.data;
  });
};